<template>
  <section-hoc
    mode="slim"
    :variant="backgroundVariant"
    class="wrapper"
    size="contain"
    position="top left"
  >
    <slot></slot>
  </section-hoc>
</template>

<script>
import SectionHoc from "./SectionHoc";

import { isMobile } from "../utils";

export default {
  components: { "section-hoc": SectionHoc },
  computed: {
    backgroundVariant() {
      return isMobile() ? 2 : 1;
    }
  }
};
</script>

<style scoped>
</style>